import client from './client';

export const fetchTags = async (query = {}): Promise<any[]> => {
    try {
        const response = await client.get<any[]>('/tags', { params: query });
        return response.data;
    } catch (error) {
        console.error('Error fetching tags:', error);
        throw error;
    }
};

export const fetchTagById = async (id: string): Promise<any> => {
    try {
        const response = await client.get<any>(`/tags/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching tag:', error);
        throw error;
    }
};

export const postTag = async (payload: any, token: string): Promise<any> => {
    try {
        const response = await client.post<any>('/tags', payload, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error creating tag:', error);
        throw error;
    }
};

export const updateTag = async (payload: any, id: string, token: string): Promise<any> => {
    try {
        const response = await client.patch<any>(`/tags/${id}`, payload, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error updating tag:', error);
        throw error;
    }
};

export const removeTag = async (id: string, token: string): Promise<any> => {
    try {
        const response = await client.delete<any>(`/tags/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting tag:', error);
        throw error;
    }
};

export const updateTagOrders = async (payload: any, token: string): Promise<any> => {
    try {
        const response = await client.patch<any>('/tags/order/save', payload, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting tag:', error);
        throw error;
    }
};

export const updateReadOrders = async (payload: any, token: string): Promise<any> => {
    try {
        const response = await client.patch<any>('/reads/order/change', payload, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting tag:', error);
        throw error;
    }
};
